/**
 * News component
 *
 * Funktionen für News-Beiträge.
 */

import { onDomReady } from '../utils/dom';

/**
 * Durch einen Klick auf einen News-Beitrag wird automatisch der Link zur
 * Detailseite aufgerufen.
 */
function linkNewsBox() {
    const linkedPosts = document.querySelectorAll('.linked-post');

    for (const news of linkedPosts) {
        news.addEventListener('click', (e) => {
            // Wenn das geklickte Element ein Link ist, wird abgebrochen
            if (e.target instanceof HTMLElement && e.target.closest('a')) {
                return;
            }

            // Sonst wird der Link aufgerufen
            news.querySelector('p.more a')?.click();
        });
    }
}

onDomReady(() => {
    linkNewsBox();
});
